"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BIEventsMessagingService = void 0;
var fflate_1 = require("fflate");
var consts_1 = require("../consts");
var indexedDBInitialization_1 = require("../indexeddb/indexedDBInitialization");
var formatEnv_1 = require("../tools/formatEnv");
/**
 * Service responsible for handling BI events messaging and sending.
*/
var BIEventsMessagingService = /** @class */ (function () {
    function BIEventsMessagingService() {
        this.isSendingInProgress = false;
    }
    /**
     * Create the process of sending the bi events, should be activated in interval.
     * @param biConfig - The configuration object of BI events service.
     */
    BIEventsMessagingService.prototype.sendingInterval = function (biConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var totalAmount, biEvents, e_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 10, 11, 12]);
                        if (this.isSendingInProgress === true)
                            return [2 /*return*/];
                        this.isSendingInProgress = true;
                        return [4 /*yield*/, indexedDBInitialization_1.DB.countBIEvents()];
                    case 1:
                        totalAmount = _a.sent();
                        if (!totalAmount) return [3 /*break*/, 9];
                        _a.label = 2;
                    case 2:
                        if (!(totalAmount > 0)) return [3 /*break*/, 9];
                        return [4 /*yield*/, indexedDBInitialization_1.DB.retrieveFirstNumOfBIEvents(biConfig.maxMessagesBulk)];
                    case 3:
                        biEvents = _a.sent();
                        if (!(biEvents === null || biEvents === void 0 ? void 0 : biEvents.length))
                            return [3 /*break*/, 9];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 7, , 8]);
                        // send biEvents
                        return [4 /*yield*/, this.send(biEvents, biConfig)];
                    case 5:
                        // send biEvents
                        _a.sent();
                        // if send works - - - > delete biEvents, process ends
                        return [4 /*yield*/, indexedDBInitialization_1.DB.deleteFirstNumOfBIEvents(biEvents.length)];
                    case 6:
                        // if send works - - - > delete biEvents, process ends
                        _a.sent();
                        // Subtract the number of events deleted from the DB
                        totalAmount -= biEvents.length;
                        console.log("BI events sent successfully");
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _a.sent();
                        // if not work - - - > notify, and continue running as usual 
                        console.log("BI events sent Failed");
                        return [3 /*break*/, 9];
                    case 8: return [3 /*break*/, 2];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_2 = _a.sent();
                        console.error("Interval BI events sending Failed", e_2);
                        return [3 /*break*/, 12];
                    case 11:
                        this.isSendingInProgress = false;
                        return [7 /*endfinally*/];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    ;
    /**
     * Sends a batch of BI events to the configured endpoint.
     * @param biEvents - An array of BI events to be sent.
     * @param biConfig - The configuration object of BI events service.
     * @returns Response from the server.
     */
    BIEventsMessagingService.prototype.send = function (biEvents, biConfig) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedEvents, stringifiedEvents, uint8Array, zippedEvents, response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formattedEvents = this.formatEvents(biEvents, biConfig);
                        stringifiedEvents = JSON.stringify(formattedEvents);
                        uint8Array = new TextEncoder().encode(stringifiedEvents);
                        zippedEvents = (0, fflate_1.gzipSync)(uint8Array);
                        return [4 /*yield*/, fetch(biConfig.url, {
                                method: 'POST',
                                body: zippedEvents,
                                headers: __assign({ "Content-Type": 'application/gzip', "Accept-Encoding": 'gzip, deflate, br', Accept: "*/*" }, (((_a = biConfig.getAccessToken) === null || _a === void 0 ? void 0 : _a.call(biConfig)) && { Authorization: biConfig.getAccessToken() }))
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new Error("HTTP error! status: ".concat(response.status));
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Formats BI events according to the required instrumentation structure before sending.
     * @param biEvents - An array of BI events to be formatted.
     * @param biConfig - The configuration object of BI events service.
     * @returns An object representing the formatted BI events ready for transmission.
     */
    BIEventsMessagingService.prototype.formatEvents = function (biEvents, biConfig) {
        var _this = this;
        var eventsList = biEvents.map(function (biEvent) {
            var _a;
            var biEventDataTypeKey = consts_1.biEventTypeToLogMap[biEvent.type];
            return {
                header: {
                    id: biEvent.id,
                    timestampMachine: _this.formatLocalISOString(),
                    sessionId: biEvent.sessionId,
                    component: biEvent.component,
                    sessionType: biEvent.sessionType,
                    type: biEvent.type
                },
                data: (_a = {},
                    _a[biEventDataTypeKey] = biEvent.event,
                    _a)
            };
        });
        return {
            app: biConfig.app,
            clientId: biConfig.clientId,
            env: (0, formatEnv_1.formatEnv)(biConfig.env),
            v: consts_1.BIInstrumentationVersion,
            eventsList: eventsList
        };
    };
    BIEventsMessagingService.prototype.formatLocalISOString = function (date) {
        if (date === void 0) { date = new Date(); }
        var pad = function (num) { return String(num).padStart(2, '0'); };
        var offset = -date.getTimezoneOffset();
        var sign = offset >= 0 ? '+' : '-';
        var hours = pad(Math.floor(Math.abs(offset) / 60));
        var minutes = pad(Math.abs(offset) % 60);
        return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), "T") +
            "".concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds())) +
            "".concat(sign).concat(hours, ":").concat(minutes);
    };
    return BIEventsMessagingService;
}());
exports.BIEventsMessagingService = BIEventsMessagingService;
